module.exports = __webpack_public_path__ + "static/media/logo_fenacor.9a7e4dcb.png";